export class WordpressCredentialsDialogController {
    public static $inject: string[] = [
        "$mdDialog",
        "wordpressService"
    ];

    public isLoggingIn: boolean = false;
    public loginError: string = "";
    public wpUsername: string = "";
    public wpPassword: string = "";

    private $mdDialog;
    private wordpressService;

    constructor(
        $mdDialog,
        wordpressService
    ) {
        this.$mdDialog = $mdDialog;
        this.wordpressService = wordpressService;
    }

    public cancel() {
        this.$mdDialog.cancel();
    }

    public logIn(form) {
        if (form.$valid) {
            this.isLoggingIn = true;
            this.loginError = "";

            this.wordpressService.logIn(this.wpUsername, this.wpPassword)
                .then(() => {
                    this.$mdDialog.hide();
                })
                .catch(error => {
                    if (error.status) {
                        switch (error.status) {
                            case -1:
                                this.loginError = "Impossible de communiquer avec Wordpress";
                                break;
                            case 403:
                                this.loginError = "Nom d'utilisateur ou mot de passe invalide";
                                break;
                            default:
                                this.loginError = "Une erreur non supportée est survenue";
                                break;
                        }
                    }

                    this.isLoggingIn = false;
                });
        }
    }
}
